module.exports = __webpack_public_path__ + "static/media/PB_Y_02.7b3b3ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_02.png
// module id = 231
// module chunks = 0